import * as React from "react";

type GradientStop = {
  offset: string | number;
  color: string;
  opacity?: number;
};

type LinearGradientConfig = {
  id?: string;
  x1?: string;
  y1?: string;
  x2?: string;
  y2?: string;
  stops: GradientStop[];
};

export type SvgComponentProps = Omit<
  React.SVGProps<SVGSVGElement>,
  "color" | "fill"
> & {
  name?: string;
  color?: string;
  colorGradient?: LinearGradientConfig;
  pathData: string;
};

export type SvgIconProps = Omit<SvgComponentProps, "pathData">;

export const SvgComponent: React.FC<SvgComponentProps> = ({
  name,
  color,
  colorGradient,
  pathData,
  ...props
}) => (
  <svg
    role="img"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-label={name}
    {...props}
  >
    <title>{name}</title>
    {color === undefined && colorGradient ? (
      <defs>
        <linearGradient
          id={colorGradient.id ?? "gradient"}
          x1={colorGradient.x1 ?? "0%"}
          y1={colorGradient.y1 ?? "0%"}
          x2={colorGradient.x2 ?? "100%"}
          y2={colorGradient.y2 ?? "0%"}
        >
          {colorGradient.stops.map((stop, index) => (
            <stop
              key={index}
              offset={
                typeof stop.offset === "number"
                  ? `${stop.offset}%`
                  : stop.offset
              }
              stopColor={stop.color}
              stopOpacity={stop.opacity}
            />
          ))}
        </linearGradient>
      </defs>
    ) : null}
    <path
      fill={
        color !== undefined
          ? color
          : colorGradient
            ? `url(#${colorGradient.id ?? "gradient"})`
            : "currentColor"
      }
      d={pathData}
    />
  </svg>
);
